import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { fuseConfig } from 'app/fuse-config';
import { FuseConfig } from '@fuse/types';
import { DomSanitizer } from '@angular/platform-browser';
import { reject } from 'lodash';

@Injectable()
export class ProjectService implements Resolve<any>, OnDestroy {

    private _unsubscribeAll: Subject<any>;
    private _fuseConfig: FuseConfig;

    routeParams: any;
    project: any;
    onProjectChanged: BehaviorSubject<any>;
    onMemberProjectsChanged: BehaviorSubject<any>;
    onProjectJoined: BehaviorSubject<any>;
    onDemogsChanged: BehaviorSubject<any>;

    language = 'sr'; // temporary!!!

    /**
     * Constructor
     *
     * @param {HttpClient} _http
     */
    constructor(
        private _http: HttpClient,
        private _router: Router,
        private sanitizer: DomSanitizer
    ) {
        this._fuseConfig = fuseConfig;
        this._unsubscribeAll = new Subject();

        // Set the defaults
        this.onProjectChanged = new BehaviorSubject({});
        this.onMemberProjectsChanged = new BehaviorSubject({});
        this.onProjectJoined = new BehaviorSubject({});
        this.onDemogsChanged = new BehaviorSubject({});
    }

    /**
     * Resolver
     *
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {

            Promise.all([
                this.getProject(),
                this.getProjectDemogs()

            ])
                .then(
                    () => {
                        resolve();
                    }
                )
                .catch(err => Promise.reject(err))
                .then(() => { }, err => {
                    this._router.navigate(['/home']);
                });
        });
    }

    public getProject(): Promise<any> {

        const companyId = localStorage.getItem('company');
        if (!companyId) {
            return new Promise(reject);
        }

        return new Promise((resolve, reject) => {
            // this._http.get(this._fuseConfig.api.url + '/public/project/get/' + this.routeParams.id + '/' + this.language) //  + '?referrer=Direct'
            this._http.get(this._fuseConfig.api.url + '/portal/erp/' + companyId + '/project/get/' + this.routeParams.id + '/' + localStorage.getItem('lang'))
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        this.project = response;
                        this.onProjectChanged.next(this.project);
                        resolve(response);
                    }, reject);
        });
    }

    public listUserProjects(
        page: number = 1, limit: number = 20, orderBy: string = 'id', order: string = 'asc', search: string = '', lang: string = localStorage.getItem('lang')
    ): Promise<any> {

        const params = {
            limit: limit,
            order_by: orderBy,
            order: order,
            search: search,
            lang: lang
        };

        return new Promise((resolve, reject) => {
            this._http.post(this._fuseConfig.api.url + '/portal/project/listing', params)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        this.onMemberProjectsChanged.next(response);
                        resolve(response);
                    }, reject);
        });
    }

    public signInToProject(): Promise<any> {

        return new Promise((resolve, reject) => {
            this._http.get(this._fuseConfig.api.url + '/portal/project/join/' + this.routeParams.id)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        this.onProjectJoined.next(response);
                        resolve(response);
                    }, reject);
        });
    }

    public getProjectDemogs(): Promise<any> {

        return new Promise((resolve, reject) => {
            this._http.get(this._fuseConfig.api.url + '/public/project/demog/get/' + this.routeParams.id)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        this.onDemogsChanged.next(response);
                        resolve(response);
                    }, reject);
        });
    }

    /**
     * Lifecycle hooks
     */

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
